import { render, staticRenderFns } from "./TimeTrackerEventHoliday.vue?vue&type=template&id=126bba86"
import script from "./TimeTrackerEventHoliday.vue?vue&type=script&lang=js"
export * from "./TimeTrackerEventHoliday.vue?vue&type=script&lang=js"
import style0 from "./TimeTrackerEventHoliday.vue?vue&type=style&index=0&id=126bba86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports